module.exports = __webpack_public_path__ + "static/media/peopleThumbnail.df61ff63.jpg";